import ExpandableAccordion from "@/components/atom/accordion/expandable/ExpandableAccordion";
import { useWorkDataStore } from "@/store/work.store";

import { WorkText } from "@/components/atom/text/work/WorkText";
import { WorkTitle } from "@/components/atom/title/work/WorkTitle";
import { COMMON_TEXT } from "@/constants/text";
import { Accordion, Flex } from "@mantine/core";

const DrawingPath = Object.assign(
  {},
  {
    Title: WorkTitle,
    Text: WorkText,
    Accordion: ExpandableAccordion,
  }
);

export const DrawingPathInform = () => {
  const { workData } = useWorkDataStore((state) => ({
    workData: state.workData,
  }));
  const { work } = workData;

  return (
    <DrawingPath.Accordion>
      <Accordion.Item value="ledgerTable">
        <Accordion.Control>
          <Flex w={"100%"} justify={"space-between"}>
            <DrawingPath.Title c={"#FFFFFF"} order={5}>
              {COMMON_TEXT.TITLE.DRAWING_PATH}
            </DrawingPath.Title>
          </Flex>
        </Accordion.Control>
        <Accordion.Panel>
          <Flex w={"100%"} direction={"column"} p={10} gap={10}>
            <Flex justify={"space-between"}>
              <DrawingPath.Title size={"sm"}>
                {COMMON_TEXT.TITLE.DRAWING_PATH}
              </DrawingPath.Title>
              <Flex wrap={"wrap"}>
                <DrawingPath.Text fw={"bold"}>
                  [{work?.item?.drawingPath}]
                </DrawingPath.Text>
              </Flex>
            </Flex>
          </Flex>
        </Accordion.Panel>
      </Accordion.Item>
    </DrawingPath.Accordion>
  );
};
